import { render, staticRenderFns } from "./SysGatewayRouteList.vue?vue&type=template&id=d70109ac"
import script from "./SysGatewayRouteList.vue?vue&type=script&lang=js"
export * from "./SysGatewayRouteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d70109ac')) {
      api.createRecord('d70109ac', component.options)
    } else {
      api.reload('d70109ac', component.options)
    }
    module.hot.accept("./SysGatewayRouteList.vue?vue&type=template&id=d70109ac", function () {
      api.rerender('d70109ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/SysGatewayRouteList.vue"
export default component.exports